module.exports = __webpack_public_path__ + "static/media/question.6be3a9a2.svg";